module.exports = __webpack_public_path__ + "img/contact-details.6db5419e.svg";